export default __webpack_public_path__ + "d9b37edf228355fcd3f25dd30d93a6d3.png";